import { FaUsers } from 'react-icons/fa'

const PHONE_DISPLAY = '(844) 284-2739'
const PHONE_TEL = 'tel:+18442842739'

export default function SiteFooter() {
  return (
    <footer className="bg-neutral-200 text-neutral-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
          <div className="flex justify-center lg:justify-start">
            <div className="flex items-center gap-3">
              <img
                src="/logo2.png"
                alt="Aegis Professional Services"
                className="h-20 w-20 object-contain flex-shrink-0"
              />
              <div>
                <div className="text-2xl font-bold tracking-wider text-aps-red leading-none">AEGIS</div>
                <div className="flex items-center gap-1.5 mt-1">
                  <span className="h-px w-4 bg-aps-red" />
                  <span className="text-[10px] font-semibold tracking-[0.15em] text-neutral-800 uppercase">
                    Professional Services
                  </span>
                  <span className="h-px w-4 bg-aps-red" />
                </div>
                <a
                  href={PHONE_TEL}
                  className="mt-3 inline-block text-sm font-semibold tracking-wide text-neutral-800 hover:text-aps-red"
                >
                  {PHONE_DISPLAY}
                </a>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-6 justify-center">
            <span className="hidden lg:block h-16 w-px bg-neutral-400" />
            <div className="flex items-center gap-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-neutral-800">
                <FaUsers className="h-7 w-7 text-neutral-800" />
              </div>
              <div className="text-xs font-bold tracking-wide uppercase leading-relaxed max-w-[220px]">
                Dedicated to protecting your operations. Focused on your success. Committed to what matters most.
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4 justify-center lg:justify-end">
            <img
              src="/assets/headers/texas.png"
              alt=""
              className="h-24 w-auto flex-shrink-0 object-contain"
              aria-hidden="true"
            />
            <div className="text-xl sm:text-2xl font-bold tracking-wide uppercase leading-tight">
              <span className="text-neutral-900">Proudly</span>
              <br />
              <span className="text-aps-red">Serving Texas</span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-300 bg-neutral-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4 text-center text-xs text-neutral-500">
          © {new Date().getFullYear()} Aegis Professional Services
          <span className="mx-2 text-neutral-400">·</span>
          <a href={PHONE_TEL} className="hover:text-aps-red">
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </footer>
  )
}
